import React, { useState } from "react";
import { RenderKilogramo } from "../../../../../../Utils/renderField/renderReadField";

const defaultValues = {
    peso: 0,
    pacas: 0,
};

export const TotalesRecepcion = (props) => {
    const { pallets = [] } = props;

    const totalPeso =
        pallets.reduce(
            (total, pallet) => total + (pallet.total_peso || 0),
            0,
        ) || 0;

    const totalPesoAprobado = pallets.reduce((total, pallet) => {
        if (pallet.recibido_bodega) {
            return total + (pallet.total_peso || 0);
        }
        return total;
    }, 0);

    const totalPesoRechazado = pallets.reduce((total, pallet) => {
        if (!pallet.recibido_bodega) {
            return total + (pallet.total_peso || 0);
        }
        return total;
    }, 0);

    return (
        <React.Fragment>
            <div
                className="py-3 px-3 mt-3 mb-4"
                style={{ backgroundColor: "#ebebeb", borderRadius: "1rem" }}
            >
                <div className="d-flex justify-content-between gap-1rem flex-wrap">
                    <div>
                        <label className="text-nowrap mb-1 pl-0 font-weight-400">
                            Total enviado:
                        </label>
                        <h4 className="text-nowrap">
                            <RenderKilogramo value={totalPeso} decimals={3} />
                        </h4>
                    </div>
                    <div>
                        <label className="text-nowrap mb-1 pl-0 font-weight-400">
                            Rechazado:
                        </label>
                        <h4 className="text-nowrap">
                            <RenderKilogramo
                                value={totalPesoRechazado}
                                decimals={3}
                            />
                        </h4>
                    </div>
                    <div>
                        <label className="text-nowrap mb-1 pl-0 font-weight-400">
                            Total aprobado:
                        </label>
                        <h4 className="text-nowrap">
                            <RenderKilogramo
                                value={totalPesoAprobado}
                                decimals={3}
                            />
                        </h4>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
